import { getMarketCode } from './dataLayer'

const LABEL_CATEGORY_NAME = 'cat/capsule-range-label'
const LABEL_CATEGORY_NAME_MACHINE = 'cat/machine-range-label'
export const RANGE_CATEGORY_NAME = 'cat/capsule-range'
const FAIR_TRADE_CATEGORY_NAME = 'cat/capsule-range-fair-trade'
const VERTUO_NEXT_CATEGORY_NAME = 'cat/capsule-attribute-only-vertuo-next'
const ORGANIC_EU_CATEGORY_NAME = 'capsule-attribute-organic-eu'
const RAINFOREST_CATEGORY_NAME = 'capsule-attribute-rainforest'
const SUSTAINABILITY_CATEGORY_NAME = 'capsule-attribute-sustainability'
const ARABICA_CATEGORY_NAME = 'capsule-attribute-arabica'
const PRODUCT_HIGHLIGHT_CATEGORY_NAME = 'cat/capsule-attribute-highlight'
const TECHNOLOGY_CATEGORY_IDENTIFIER = '/machineTechno/'

const COMMON_URL = 'https://www.nespresso.com/shared_res/agility/commons/img/icons/'

export const FAIR_TRADE_IMG = COMMON_URL + 'fairTrade.svg'
export const ORGANIC_LOGO_IMG_EU = COMMON_URL + 'logo-organic-eu.svg'
export const ORGANIC_LOGO_IMG_US = COMMON_URL + 'logo-organic-us.svg'
export const ORGANIC_LOGO_IMG_CA = COMMON_URL + 'logo-organic-ca.svg'
export const ORGANIC_LOGO_IMG_BR = COMMON_URL + 'logo-organic-br.svg'
export const ORGANIC_LOGO_IMG_JP = COMMON_URL + 'logo-organic-jp.svg'
export const ORGANIC_LOGO_IMG_BE = COMMON_URL + 'logo-organic-be.png'

export const VERTUONEXT_LOGO_IMG = COMMON_URL + 'logo-only-vertuo-next.svg'
export const RAINFOREST_LOGO_IMG = COMMON_URL + 'logo-rainforest.svg'
export const SUSTAINABILITY_LOGO_IMG = COMMON_URL + 'logo-sustainability.svg'
export const Q_CERTIFICATION_ARABICA_LOGO_IMG = COMMON_URL + 'q_grade_certification_arabica.svg'
export const DESIGN_AWARD_2021_IMG = COMMON_URL + 'design_award_2021.svg'

export const LOGO_IMG_MAP = {
    fair_trade: FAIR_TRADE_IMG,
    is_organic: getOrganicLogo(),
    only_vertuo_next: VERTUONEXT_LOGO_IMG,
    is_q_certified_arabica: Q_CERTIFICATION_ARABICA_LOGO_IMG,
    is_rainforest: RAINFOREST_LOGO_IMG,
    is_sustainable: SUSTAINABILITY_LOGO_IMG,
    is_design_award_2021: DESIGN_AWARD_2021_IMG
}

export function getOrganicLogo() {
    let organicLogoImg = ORGANIC_LOGO_IMG_EU

    switch (getMarketCode()) {
        case 'us':
            organicLogoImg = ORGANIC_LOGO_IMG_US
            break
        case 'ca':
            organicLogoImg = ORGANIC_LOGO_IMG_CA
            break
        case 'br':
            organicLogoImg = ORGANIC_LOGO_IMG_BR
            break
        case 'jp':
            organicLogoImg = ORGANIC_LOGO_IMG_JP
            break
        case 'be':
            organicLogoImg = ORGANIC_LOGO_IMG_BE
            break
    }

    return organicLogoImg
}

/**
 * retrieves the list of categories of type Vertuo Next
 * @param {category[]} categories
 */
export function getVertuoNext(categories) {
    return categories.find(category => isVertuoNext(category))
}

/**
 * returns true when the category is product vertuo next
 * @param {category} category
 */
function isVertuoNext(category) {
    return getCategoryRegEx(VERTUO_NEXT_CATEGORY_NAME).test(category.id)
}

/**
 * retrieves the list of categories of type organic EU
 * @param {category[]} categories
 */
export function getOrganicEu(categories) {
    return categories.find(category => isOrganicEu(category))
}

/**
 * returns true when the category is product organic EU
 * @param {category} category
 */
function isOrganicEu(category) {
    return getCategoryRegEx(ORGANIC_EU_CATEGORY_NAME).test(category.id)
}

/**
 * retrieves the list of categories of type rainforest
 * @param {category[]} categories
 */
export function getRainforest(categories) {
    return categories.find(category => isRainforest(category))
}

/**
 * returns true when the category is rainforest
 * @param {category} category
 */
function isRainforest(category) {
    return getCategoryRegEx(RAINFOREST_CATEGORY_NAME).test(category.id)
}

/**
 * retrieves the list of categories of type sustainability
 * @param {category[]} categories
 */
export function getSustainability(categories) {
    return categories.find(category => isSustainability(category))
}

/**
 * retrieves the list of categories of type arabica
 * @param {category[]} categories
 */
export function getArabica(categories) {
    return categories.find(category => isArabica(category))
}

/**
 * returns true when the category is arabica
 * @param {category} category
 */
function isArabica(category) {
    return getCategoryRegEx(ARABICA_CATEGORY_NAME).test(category.id)
}

/**
 * returns true when the category is sustainability
 * @param {category} category
 */
function isSustainability(category) {
    return getCategoryRegEx(SUSTAINABILITY_CATEGORY_NAME).test(category.id)
}

/**
 * retrieves the list of categories of type label
 * @param {category[]} categories
 */
export function getLabels(categories) {
    return categories.filter(category => isLabel(category))
}

/**
 * retrieves the list of categories of type label
 * @param {category[]} categories
 */
export function getProductHighlight(categories) {
    return categories.find(category => isProductHighlight(category))
}
/**
 * retrieves the list of categories of type label
 * @param {category[]} categories
 */
export function getFairTrade(categories) {
    return categories.find(category => isFairTrade(category))
}

/**
 * returns a regex to match the tail (global) of a given local category ID
 * @param {string} categoryIdTail : should contain the end of the category ID
 */
export function getCategoryRegEx(categoryIdTail) {
    return new RegExp(categoryIdTail.replace(/\//g, '\\/'))
}

/**
 * returns true when the category is child of the label category (is type label)
 * @param {category} category
 */
function isLabel(category) {
    return (
        getCategoryRegEx(LABEL_CATEGORY_NAME).test(category.id) ||
        getCategoryRegEx(LABEL_CATEGORY_NAME_MACHINE).test(category.id)
    )
}

/**
 * returns true when the category is product highlight
 * @param {category} category
 */
function isProductHighlight(category) {
    return getCategoryRegEx(PRODUCT_HIGHLIGHT_CATEGORY_NAME).test(category.id)
}
/**
 * returns true when the category is fair trade
 * @param {category} category
 */
function isFairTrade(category) {
    return getCategoryRegEx(FAIR_TRADE_CATEGORY_NAME).test(category.id)
}

/**
 * returns true when the category is child of the range category (is type range)
 * @param {category} category
 */
export function isRange(category) {
    return category.superCategories.some(superCategory =>
        getCategoryRegEx(RANGE_CATEGORY_NAME).test(superCategory)
    )
}

export function getTechnologyName(productData, categories) {
    if (!productData || !productData.technologies || !productData.technologies.length) {
        return null
    }

    const techno = productData.technologies[0]
    const categoryNameAsSubstring = techno.substring(
        techno.indexOf(TECHNOLOGY_CATEGORY_IDENTIFIER) + TECHNOLOGY_CATEGORY_IDENTIFIER.length
    )
    const category = categories?.find(cat => cat.id === techno)

    // Backward compatibility, return name as substring if the list of categories are not available
    return category?.name || categoryNameAsSubstring
}

export function isCategoryHidden(categoryId) {
    let hideCategory = false
    // To enable AB testing: exclude categories which are to be hidden
    if (
        window.PLP_HIDE_CATEGORIES?.length &&
        window.PLP_HIDE_CATEGORIES.findIndex(c => categoryId.indexOf(c) >= 0) >= 0
    ) {
        hideCategory = true
    }

    // To enable AB testing: exclude categories except those which are to be shown
    if (window.PLP_ONLY_SHOW_CATEGORIES?.length) {
        // Default to hide
        hideCategory = true
        if (window.PLP_ONLY_SHOW_CATEGORIES.findIndex(c => categoryId.indexOf(c) >= 0) >= 0) {
            hideCategory = false
        }
    }
    return hideCategory
}
